import React from "react";
import { useState } from "react";
import { Box, Card, Grid, Typography, Avatar } from "@mui/material";
import { IoArrowRedoOutline } from "react-icons/io5";
import CriticalActivityDialog from "./CriticalActivitiesPopup";
import UpcomingCriticalActivityDialog from "./UpcomingCriticalActivitiesPopup";
import WeeklyCriticalActivityDialog from "./WeeklyCriticalActivitiesPopup";
import{mapActivitiesKpis} from "view/dashboard/schedule/scheduleKpiMapper";
import dayjs from "dayjs";
import { enterpriseTokens } from "styles/theme";

const ActivitiesKpi = ({kpiData, category}) => {
    console.log("Category,",category);
    const today = dayjs().format("YYYY-MM-DD");
    const thirtyDaysLater = dayjs().add(30, "day").format("YYYY-MM-DD");
    const sevenDaysLater = dayjs().add(7, "day").format("YYYY-MM-DD");
    const [open, setOpen] = useState(false);
    const[openUpcoming, setOpenUpcoming]   = useState(false);
    const[openWeekly, setOpenWeekly]   = useState(false);

    const [selectedCard, setSelectedCard] = useState(null);

    const progress = localStorage.getItem('progress') || 0;
    const row = kpiData?.data?.[0];
    const totalCriticalActivities = row?.criticalActivitiesCount || 0;
    const totalUpcomingCriticalActivities = row?.upcomingCriticalActivitiesCount || 0;
    const totalWeeklyCriticalActivities = row?.weeklyCriticalActivitiesCount || 0;

    const kpiArray = mapActivitiesKpis(row);
    const accentColors = [enterpriseTokens.danger, enterpriseTokens.warning, enterpriseTokens.accent, enterpriseTokens.primary];

    const handleOpenDialog = () => {
        setOpen(true);
    };
    const handleOpeUpcomingDialog = () => {
        setOpenUpcoming(true);
    };
    const handleOpenWeeklyDialog = () => {
        setOpenWeekly(true);
    };


    const handleCloseDialog = () => {

        setOpen(false);
        setSelectedCard(null);

    };


    const handleCloseUpcomingDialog = () => {
        setOpenUpcoming(false);
       
    };

    const handleCloseWeeklyDialog = () => {
        setOpenWeekly(false);
       
    };

    return (
        <>

            <Grid container rowSpacing={1.25} columnSpacing={1.25}>
                {kpiArray?.map((card, index) => (
                    <Grid key={index} size={{ xs: 12, md: 6 }}>
                        <Card
                            elevation={0}
                            sx={{
                                boxShadow: "none",
                                border: `1px solid ${enterpriseTokens.lineSoft}`,
                                borderRadius: "3px",
                                backgroundColor: "#FFFFFF",
                                height: "100%",
                                position: "relative",
                                overflow: "hidden",
                                "&:before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: "4px",
                                    backgroundColor: accentColors[index % accentColors.length],
                                },
                            }}
                        >
                            <Box
                                display="flex"
                                alignItems="flex-start"
                                justifyContent="space-between"
                                sx={{ px: "16px", py: "18px", gap: 1.5 }}
                            >
                                <Box display="flex" alignItems="center">
                                    <Box>
                                        <Typography

                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "12px",
                                                color: enterpriseTokens.muted,
                                                fontFamily: "Inter, Outfit, sans-serif",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.04em",
                                            }}
                                        >
                                            {card.label}
                                        </Typography>
                                        <Box sx={{ display: "flex", gap: "10px", alignItems: "center", mt: "8px" }}>
                                            <Typography

                                                    sx={{
                                                        fontWeight: 700,
                                                        fontSize: "28px",
                                                        color: enterpriseTokens.navy,
                                                        lineHeight: "34px",
                                                        fontFamily: "Inter, Outfit, sans-serif",
                                                    }}
                                                >
                                                    {card.value}
                                            </Typography>
                                            {card.subLabel &&
                                                <Typography

                                                    sx={{
                                                        fontWeight: 700,
                                                        fontSize: "12px",
                                                        color: enterpriseTokens.muted,
                                                        fontFamily: "Inter, Outfit, sans-serif",
                                                    }}
                                                >
                                                    ({card.subLabel})
                                                </Typography>
                                            }
                                        </Box>
                                    </Box>
                                </Box>
                                {
                                    card.hasArrow && card.label == "Critial Activities" &&
                                    <Avatar
                                        onClick={() => handleOpenDialog()}
                                        sx={{
                                            bgcolor: "#E7E7EB",
                                            width: "37px",
                                            height: "37px",
                                            border: `1px solid ${enterpriseTokens.lineSoft}`,
                                            color: enterpriseTokens.primary,
                                            cursor: "pointer",
                                        }}
                                    >
                                        <IoArrowRedoOutline
                                            style={{
                                                color: enterpriseTokens.primary,
                                                fontSize: "20px",
                                            }}
                                        />
                                    </Avatar>
                                }
                                {
                                    card.hasArrow && card.label== "Upcoming Critical Activities" &&
                                        card.subLabel=="next 30 days" &&
                                    <Avatar
                                        onClick={() => handleOpeUpcomingDialog()}
                                        sx={{
                                            bgcolor: "#E7E7EB",
                                            width: "37px",
                                            height: "37px",
                                            border: `1px solid ${enterpriseTokens.lineSoft}`,
                                            cursor: "pointer",
                                        }}
                                    >
                                        <IoArrowRedoOutline
                                            style={{
                                                color: enterpriseTokens.primary,
                                                fontSize: "20px",
                                            }}
                                        />
                                    </Avatar>
                                }
                                {
                                    card.hasArrow && card.label== "Upcoming Critical Activities" &&
                                        card.subLabel=="next 7 days" &&
                                    <Avatar
                                        onClick={() => handleOpenWeeklyDialog()}
                                        sx={{
                                            bgcolor: "#E7E7EB",
                                            width: "37px",
                                            height: "37px",
                                            border: `1px solid ${enterpriseTokens.lineSoft}`,
                                            cursor: "pointer",
                                        }}
                                    >
                                        <IoArrowRedoOutline
                                            style={{
                                                color: enterpriseTokens.primary,
                                                fontSize: "20px",
                                            }}
                                        />
                                    </Avatar>
                                }


                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <CriticalActivityDialog
                open={open}
                onClose={handleCloseDialog}
                activityCount={totalCriticalActivities}
                category={category}
            />
            <UpcomingCriticalActivityDialog
                open={openUpcoming}
                onClose={handleCloseUpcomingDialog}
                startDate={today}
                endDate ={thirtyDaysLater}
                activityCount={totalUpcomingCriticalActivities}
                category={category}
            />
            <WeeklyCriticalActivityDialog
                open={openWeekly}
                onClose={handleCloseWeeklyDialog}
                startDate={today}
                endDate ={sevenDaysLater}
                activityCount={totalWeeklyCriticalActivities}
                category={category}
            />
        </>
    );
};

export default ActivitiesKpi;
